import * as React from 'react';
import { Fragment } from 'react';
import Pagination from '../components/Pagination';
import {
	BulkActionProps,
	BulkDeleteButton,
	DateInput,
	List,
	ListProps,
	TextInput
} from 'react-admin';
import { Theme, useMediaQuery } from '@material-ui/core';
import { ExportField, generateExporter } from '../util/Exporter';
import { Tag } from "./Tag";
import { TagList } from "./TagList";
import { TagDatagrid } from "./TagDatagrid";

export * from './Tag';
export * from './TagCreate';
export * from './TagDatagrid';
export * from './TagEdit';
export * from './TagList';
export * from './TagShow';

const TagsBulkActionButtons = (props: BulkActionProps) => (
	<Fragment>
		<BulkDeleteButton {...props} undoable={false}/>
	</Fragment>
);

export const exportFields: ExportField[] = [
	{ key: 'id', header: 'ID' },
	{ key: 'title', header: 'Title' },
	{ key: 'organization.name', header: 'Organization' }
];

export const TagsData = (props: ListProps): React.ReactElement => {
	const isXSmall = useMediaQuery<Theme>(theme => theme.breakpoints.down('xs'));
	const exportDataMapper = (entity: Tag) => entity;

	const tagsFilter = [
		<TextInput source="title" alwaysOn label="SEARCH"/>,
		<DateInput source="from__createdAt" label="FROM_CREATED_AT"
		           alwaysOn/>,
		<DateInput source="to__createdAt" label="TO_CREATED_AT"
		           alwaysOn/>
	];

	return (
		<Fragment>
			<List
				exporter={generateExporter('תגיות', exportFields, exportDataMapper)}
				{...props}
				filters={tagsFilter}
				bulkActionButtons={<TagsBulkActionButtons/>}
				title="TAGS"
				sort={{ field: '_createdAt', order: 'DESC' }}
				perPage={20}
				pagination={<Pagination/>}
			>
				{isXSmall ? <TagList/> : <TagDatagrid/>}
			</List>
		</Fragment>
	);
};
